import { defineDirective } from '~/scripts/utils/alpine'

function assertTheme(theme: string): theme is 'page' | 'light' | 'dark' {
  return ['page', 'light', 'dark'].includes(theme)
}

/**
 * x-section-theme directive
 * @example Set the theme to 'light' when the section is in view
 * <div x-section-theme="light"></div>
 * @example Set the theme to 'dark' when the section is in view and 'page' when it's not
 * <div x-section-theme="dark,page"></div>
 * @example Set the theme to 'page' when the section is not in view
 * <div x-section-theme=",page"></div>
 */
export default defineDirective(async (element, { expression }, { cleanup }) => {
  if (!expression || typeof expression !== 'string')
    return

  const [enterTheme, leaveTheme] = expression.split(',')

  const [{ gsap }, { ScrollTrigger }] = await Promise.all([import('gsap'), import('gsap/ScrollTrigger')])
  gsap.registerPlugin(ScrollTrigger)

  const st = ScrollTrigger.create({
    trigger: element,
    start: 'top 30%',
    end: 'bottom 20%',
    onToggle: ({ isActive }) => {
      if (isActive && assertTheme(enterTheme)) {
        window.$store?.ui.setTheme(enterTheme)
      }
      if (!isActive && assertTheme(leaveTheme)) {
        window.$store?.ui.setTheme(leaveTheme)
      }
    },
  })

  cleanup(() => {
    st.kill()
  })
})
